(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/prescript.js');

'use strict';

svs.eurojackpot = svs.eurojackpot || {};
svs.eurojackpot.views = svs.eurojackpot.views || {};
svs.eurojackpot.templates = svs.eurojackpot.templates || {};
svs.eurojackpot.router = svs.eurojackpot.router || {};
svs.eurojackpot.routes = svs.eurojackpot.routes || {};
svs.eurojackpot.components = svs.eurojackpot.components || {};
svs.eurojackpot.logger = svs.eurojackpot.logger || new svs.core.log.Logger('module:eurojackpot');

 })(window);